import React, { PureComponent } from 'react';

import { Svg, filterProps } from '@lglp/components';
import PropTypes from 'prop-types';

import { ICON } from 'translations';

import { translate } from '../mixins/composer';

export class PosteoComponent extends PureComponent {
  static displayName = 'PosteoComponent';

  static handledProps = ['title'];

  static propTypes = {
    title: PropTypes.string,
  };

  static defaultProps = {
    title: ICON.POSTEO,
  };

  render() {
    const { title, t } = this.props;
    const rest = filterProps(PosteoComponent, this.props);

    return (
      <Svg title={t(title)} viewBox="0 0 146.81 105.74" {...rest}>
        <defs />
        <g id="Calque_2" data-name="Calque 2">
          <g id="Calque_1-2">
            <path
              className="posteo-1"
              d="M52.59 45.32h31.6a8 8 0 0 1 8 8v51.41h-31.6a8 8 0 0 1-8-8V45.32z"
            />
            <path
              className="posteo-1"
              d="M100.37 45.32H132v51.42a8 8 0 0 1-8 8H92.37V53.32a8 8 0 0 1 8-8z"
              transform="rotate(-180 112.165 75.03)"
            />
            <path
              className="posteo-2"
              d="M104.72 61.61H123m-18.28 7.52H123m-14.25 9.8h10.21v10.21h-10.21zM20.6 10.92A19.61 19.61 0 0 0 1 30.52 26.59 26.59 0 0 0 4.92 43.2l15.2 25.62 16-25.45a24.94 24.94 0 0 0 4.08-12.85 19.61 19.61 0 0 0-19.6-19.6z"
            />
            <circle className="posteo-2" cx={20.6} cy={29.6} r={7.17} />
            <path
              d="M82.54 10.65A10.88 10.88 0 0 0 77 9.17a11 11 0 0 0-4.23.83 10.83 10.83 0 0 0-3.56 2.37A11 11 0 0 0 66 20.19a10.89 10.89 0 0 0 1.48 5.56 11.09 11.09 0 0 0 4 4A10.71 10.71 0 0 0 77 31.24a10.88 10.88 0 0 0 5.55-1.48 11.25 11.25 0 0 0 4-4 11.15 11.15 0 0 0 0-11.1 11.22 11.22 0 0 0-4.01-4.01zm2.82 9.54a8.38 8.38 0 0 1-12.55 7.26 8.37 8.37 0 0 1-3-3.06 8.28 8.28 0 0 1-1.12-4.2A8.4 8.4 0 0 1 69.76 16a8.22 8.22 0 0 1 3-3.06 8.46 8.46 0 0 1 8.38 0 8.15 8.15 0 0 1 3 3.06 8.4 8.4 0 0 1 1.22 4.19zm-24.54-9.57a7.7 7.7 0 0 0-3.87-1h-5.5a.52.52 0 0 0-.45.25l-1 1.64a.53.53 0 0 0 0 .49.54.54 0 0 0 .46.26h1.92v18.07a.52.52 0 0 0 .52.52h1.63a.52.52 0 0 0 .52-.52v-5.25H57a7.73 7.73 0 0 0 7.75-7.75 7.67 7.67 0 0 0-1-3.87 7.59 7.59 0 0 0-2.93-2.84zM62 17.33a5 5 0 0 1-1.42 3.58 4.7 4.7 0 0 1-3.58 1.5h-1.94V12.26H57a5.19 5.19 0 0 1 2.46.62 5.06 5.06 0 0 1 1.89 1.79 4.8 4.8 0 0 1 .65 2.66zm62.2-7.74h-9.28a.52.52 0 0 0-.52.52V16h-1a.53.53 0 0 0-.45.25l-1 1.64a.51.51 0 0 0 0 .52.53.53 0 0 0 .46.27h1.94v11.65a.52.52 0 0 0 .52.52h9.28a.52.52 0 0 0 .52-.52V28.7a.52.52 0 0 0-.52-.52h-7.12v-9.49h4.33a.52.52 0 0 0 .52-.52v-1.64a.52.52 0 0 0-.52-.52h-4.33v-3.75h7.12a.52.52 0 0 0 .52-.52v-1.63a.52.52 0 0 0-.47-.52zm-28.03 8.85l-2.33-.6a2.79 2.79 0 0 1-1.56-1 3 3 0 0 1 .25-3.95 2.82 2.82 0 0 1 2.11-.9 2.74 2.74 0 0 1 2.58 1.47.53.53 0 0 0 .71.19l1.43-.8a.54.54 0 0 0 .19-.72 5.73 5.73 0 0 0-2.08-2 5.57 5.57 0 0 0-2.83-.77A5.65 5.65 0 0 0 89 15a5.59 5.59 0 0 0 1.16 3.45 5.49 5.49 0 0 0 3 2l2.32.6a3.67 3.67 0 0 1 2 1.29 3.62 3.62 0 0 1 .78 2.37 3.68 3.68 0 0 1-1.08 2.69 3.63 3.63 0 0 1-2.71 1.11 3.7 3.7 0 0 1-2.36-.82 3.65 3.65 0 0 1-1.36-2.14.51.51 0 0 0-.24-.33.49.49 0 0 0-.41-.05l-1.55.44a.53.53 0 0 0-.36.63 6.55 6.55 0 0 0 2.3 3.55A6.45 6.45 0 0 0 101 24.68a6.46 6.46 0 0 0-4.79-6.24zm49.15-3.79a11.19 11.19 0 0 0-4-4 10.89 10.89 0 0 0-5.56-1.48 11.07 11.07 0 0 0-4.23.83 10.83 10.83 0 0 0-3.53 2.37 11.2 11.2 0 0 0-2.39 3.57 11 11 0 0 0-.84 4.25 10.8 10.8 0 0 0 1.49 5.56 11.19 11.19 0 0 0 4 4 11.15 11.15 0 0 0 11.1 0 11.14 11.14 0 0 0 4-4 11.08 11.08 0 0 0 0-11.1zm-1.18 5.54a8.28 8.28 0 0 1-1.12 4.2 8.39 8.39 0 0 1-3.02 3.06 8.35 8.35 0 0 1-11.42-3.06 8.18 8.18 0 0 1-1.12-4.2 8.29 8.29 0 0 1 1.08-4.19 8.15 8.15 0 0 1 3.05-3 8.44 8.44 0 0 1 8.41 0 8.15 8.15 0 0 1 3 3 8.3 8.3 0 0 1 1.14 4.19zm-32.06-10.08a.52.52 0 0 0-.52-.52h-9.66a.52.52 0 0 0-.52.52v1.63a.52.52 0 0 0 .52.52h3.49v18.07a.52.52 0 0 0 .52.52h1.64a.52.52 0 0 0 .52-.52V12.26h3.49a.52.52 0 0 0 .52-.52zm11.23-2.77l3.67-3.67L123.31 0v3.67h-3.67l3.67 3.67z"
              fill="#fff"
            />
          </g>
        </g>
      </Svg>
    );
  }
}

export default translate(PosteoComponent);
